/**
 * 份额条 (纯 HTML, 不依赖 recharts): 横向条形图, 按值降序, 尾部折叠成「其他」。
 *
 * 用横条而不是旧版的环形图: 模型数常常 >6 个、数值接近时环形图读不出差异;
 * 模型名较长, 横条把名字放在条上方, 手机 375px 也不会被截断。
 * 每一行都直接标出数值和占比, 不依赖悬停或颜色。
 */
import { cn } from "@/lib/utils";
import { pct, type ShareItem } from "../series";

interface Props {
  items: ShareItem[];
  format?: (v: number) => string;
  empty?: string;
  className?: string;
}

export function ShareBars({ items, format = (v) => v.toLocaleString(), empty = "暂无数据", className }: Props) {
  if (!items.length) {
    return <div className="text-sm text-muted-foreground py-8 text-center">{empty}</div>;
  }
  const max = Math.max(...items.map((x) => x.value));
  return (
    <ul className={cn("space-y-2.5", className)}>
      {items.map((it) => (
        <li key={it.key} title={`${it.label}: ${format(it.value)} (${pct(it.share)})`}>
          <div className="flex items-baseline justify-between gap-3 text-xs">
            <span className={cn("truncate", it.other ? "text-muted-foreground" : "text-foreground font-mono")}>
              {it.label}
            </span>
            <span className="shrink-0 tabular-nums">
              <span className="font-medium text-foreground">{format(it.value)}</span>
              <span className="ml-1.5 text-muted-foreground">{pct(it.share)}</span>
            </span>
          </div>
          <div className="mt-1 h-2.5">
            <div
              className="h-full rounded-r"
              style={{
                width: `${Math.max((it.value / max) * 100, 0.5)}%`,
                background: it.other ? "hsl(var(--muted-foreground))" : "var(--chart-1)",
                opacity: it.other ? 0.45 : 1,
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
